var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[(_vm.imgViewerVisible)?_c('el-image-viewer',{attrs:{"on-close":_vm.closeImgViewer,"url-list":_vm.imgList}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }